export default "__VITE_ASSET__2db7cc30__"